module.exports = __webpack_public_path__ + "asset/image-iconCategoryGroceries-542450aef0d72da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryGroceries.svg
// module id = mTmz
// module chunks = 0